import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[eaNotificationHost]',
    standalone: false
})
export class PrNotificationHostDirective {
  constructor(public viewContainerRef: ViewContainerRef) {}
}
